import { useState } from "react";
import { MarkdownContent } from "../ui/MarkdownContent";
import type { BrandingSettings } from "../../lib/settings/brandingTypes";
import { cn } from "../../utils/cn";

export type AuthBrandingHeaderProps = {
  title: string;
  subtitle: string;
  authPages?: {
    showLogo: boolean;
    showMessage: boolean;
    messageMarkdown: string;
  };
  branding?: BrandingSettings | null;
  className?: string;
};

export const AuthBrandingHeader = ({
  title,
  subtitle,
  authPages,
  branding,
  className,
}: AuthBrandingHeaderProps) => {
  const [logoError, setLogoError] = useState(false);
  const showLogo = authPages?.showLogo ?? true;
  const showMessage = authPages?.showMessage ?? true;
  const messageMarkdown = authPages?.messageMarkdown?.trim() ?? "";
  // Use resolvedFullLogoUrl directly — it contains either custom logo or default fallback
  const resolvedLogoUrl = branding?.resolvedFullLogoUrl ?? "";
  const hasContent = showLogo || showMessage;

  if (!hasContent) {
    return null;
  }

  return (
    <div className={cn("mb-8 text-center", className)}>
      {showLogo && (
        <div className="mb-4 flex justify-center">
          {resolvedLogoUrl && !logoError ? (
            <img
              src={resolvedLogoUrl}
              alt="QuickBox Pro"
              className="h-12 w-auto max-w-[220px] object-contain"
              onError={() => setLogoError(true)}
            />
          ) : (
            <div className="flex h-12 w-12 items-center justify-center rounded-lg bg-primary text-primary-foreground text-lg font-semibold">
              QB
            </div>
          )}
        </div>
      )}

      {showMessage && (
        messageMarkdown ? (
          <MarkdownContent
            content={messageMarkdown}
            className="mx-auto max-w-sm text-center"
          />
        ) : (
          <>
            <h1 className="text-3xl font-semibold">{title}</h1>
            <p className="text-sm text-muted-foreground">{subtitle}</p>
          </>
        )
      )}
    </div>
  );
};
